<template>

    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
        <path d="M33.3332 10L14.9998 28.3333L6.6665 20" stroke="white" stroke-width="4" stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

</template>



<script>
export default {
    name: "CheckIcon",
};
</script>